import { render } from "./ChangeTheme.vue?vue&type=template&id=2e887a63&scoped=true"
import script from "./ChangeTheme.vue?vue&type=script&lang=js"
export * from "./ChangeTheme.vue?vue&type=script&lang=js"

import "./ChangeTheme.vue?vue&type=style&index=0&id=2e887a63&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e887a63"]])

export default __exports__